import { Component, OnInit, Input, forwardRef } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

import { MarvTagComponent } from '@marv/components';
import { MarvColor, MarvColorBlue, MarvColorGreen, MarvColorOrange, MarvColorRed } from '@marv/types';

@Component({
    selector: 'app-operation-days-remaining',
    templateUrl: './days-remaining.component.html',
    styleUrls: ['./days-remaining.component.scss'],
    imports: [TranslatePipe, forwardRef(() => MarvTagComponent)]
})
export class OperationDaysRemainingComponent  implements OnInit {

    @Input({alias : 'nbDaysRemaining', required : true}) nbDaysRemaining: number|null;
    @Input({alias : 'typeDaysRemaining', required : true}) typeDaysRemaining: 'open'|'close';
    @Input({alias : 'size', required : false}) size: 'big'|'medium'|'small' = 'medium';

    constructor() { }

    ngOnInit() {}

    getColorRemainingDays(remainingDays: number): MarvColor{
        let color: MarvColor = MarvColorGreen;
        if(this.typeDaysRemaining === 'open'){
            color = MarvColorBlue;
        }
        else if(this.typeDaysRemaining === 'close'){
            if(remainingDays <= 5){
                color = MarvColorRed;
            } 
            else if(remainingDays <= 15){
                color = MarvColorOrange;
            } 
        }        
        return color;
    }
}
